var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLink16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5 3h1a1 1 0 0 1 0 2H5a3 3 0 0 0 0 6h1a1 1 0 1 1 0 2H5A5 5 0 0 1 5 3m9 5a3 3 0 0 1-3 3h-1a1 1 0 1 0 0 2h1a5 5 0 0 0 0-10h-1a1 1 0 1 0 0 2h1a3 3 0 0 1 3 3M6 7a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2z",
  clipRule: "evenodd"
})));
export default SvgIcLink16;